import { memo, useMemo } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes } from '@fortawesome/pro-solid-svg-icons'
import { faCommentCheck, faCommentSlash } from '@fortawesome/pro-light-svg-icons'

import { digObject } from '@domain-group/javascript-utils'

import { Table, Text, theme } from '@domain-group/suit-theme'

import { ApiLogModel } from '@models/apiLog'

import ApiLogActions from './ApiLogActions'

const buildColumns = () => [
  {
    title: 'Date',
    dataKey: 'dates',
    cellProps: {
      position: 'sticky',
      left: 0,
    },
    render: (datesObject: object) => {
      const createdAt = digObject(datesObject, 'created.date_time', '')

      return (
        <Text variant="ellipsis" width={120}>
          {createdAt}
        </Text>
      )
    },
  },
  {
    title: 'API Type',
    dataKey: 'api_type',
    render: (apiType: string | undefined) => apiType || 'Not Set',
  },
  {
    title: 'Event',
    dataKey: 'event',
  },
  {
    title: 'Entity',
    dataKey: 'entity_type',
    render: (entityType: string, apiLog: ApiLogModel) => (
      <Text minWidth="fit-content" variant="ellipsis">
        {`${entityType} #${apiLog.entity_id}`}
      </Text>
    ),
  },
  {
    title: 'Method',
    dataKey: 'http_method',
  },
  {
    title: 'Webhook',
    dataKey: 'webhook_id',
    render: (webhookId: number | undefined) => (
      <Text minWidth="fit-content" variant="ellipsis">
        {webhookId ? `Webhook #${webhookId}` : 'Not Set'}
      </Text>
    ),
  },
  {
    title: 'URL',
    dataKey: 'url',
    render: (url: string) => (
      <Text minWidth="fit-content" variant="ellipsis">
        {url}
      </Text>
    ),
  },
  {
    title: 'Status',
    dataKey: 'status_code',
    cellProps: {
      textAlign: 'center',
      width: 40,
    },
  },
  {
    title: 'Success',
    dataKey: 'success',
    cellProps: {
      textAlign: 'center',
    },
    render: (success: boolean) => (
      <FontAwesomeIcon icon={success ? faCheck : faTimes} />
    ),
  },
  {
    title: 'Notes',
    dataKey: 'notes',
    cellProps: {
      textAlign: 'center',
    },
    render: (notes: string) => (
      <FontAwesomeIcon
        color={notes ? theme?.colors?.blue : theme?.colors?.faintGrey}
        icon={notes ? faCommentCheck : faCommentSlash}
      />
    ),
  },
  {
    title: 'Actions',
    dataKey: 'id',
    cellProps: {
      textAlign: 'center',
    },
    render: (id: number) => <ApiLogActions apiLog={{ id }} />,
  },
]

const ApiLogTable = (props: { apiLogs: ApiLogModel[] }) => {
  const { apiLogs } = props

  const memoColumns = useMemo(() => buildColumns(), [apiLogs.length])

  return (
    <Table
      boxProps={{ border: 'none', maxHeight: 800, overflowY: 'auto' }}
      // @ts-expect-error TS2322
      columns={memoColumns}
      data={apiLogs}
      stickyHeader
    />

  )
}

export default memo(ApiLogTable)
